module.exports = __webpack_public_path__ + "img/metaCulture.b902178b.jpg";